import { getSupabase } from '@aosenuma/lib-supabase';
import type { AccionAudit, AuditPayload } from '@aosenuma/lib-types';

/**
 * Cliente-side audit emit. La fuente de verdad es el trigger DB; este
 * helper es solo para acciones que NO se pueden detectar por trigger
 * (ej. visualizaciones, descargas iniciadas). Llama Edge Function `audit-emit`.
 */
export async function emitAudit(accion: AccionAudit, payload?: AuditPayload): Promise<void> {
  const { error } = await getSupabase().functions.invoke('audit-emit', {
    body: { accion, payload: payload ?? {} },
  });
  if (error) {
    // No bloqueamos al usuario, pero loggeamos.
    console.warn('[audit-emit] fallo', error);
  }
}
